import { Avatar } from '@/components/ui';
import { ConversationWithDetails } from '@/stores/messageStore';
import { formatRelativeTime } from '@kulum/shared';
import { CheckCheck } from 'lucide-react';

interface ConversationCardProps {
  conversation: ConversationWithDetails;
  onClick?: (conversationId: string) => void;
  onOpenProfile?: (userId: string) => void;
}

export function ConversationCard({ conversation, onClick, onOpenProfile }: ConversationCardProps) {
  const { id, participant, lastMessage, lastMessageAt, unreadCount } = conversation;

  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <div className="flex w-full items-center bg-white px-4 py-3.5 text-left transition-colors active:bg-[#FAF8F5]">
      <button
        type="button"
        onClick={() => {
          if (participant.id) {
            onOpenProfile?.(participant.id);
          }
        }}
        className="relative mr-3.5 inline-flex shrink-0"
      >
        <Avatar
          src={participant.iconUrl}
          alt={participant.displayName}
          size="sm"
          className="h-[46px] w-[46px] rounded-full bg-[#D4C5A9]"
        />
        {unreadCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-white bg-copper px-1 text-[9px] font-bold leading-none text-white">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>

      <button
        type="button"
        onClick={handleClick}
        className="inline-flex min-w-0 flex-1 flex-col text-left align-top"
      >
        <div className="mb-0.5 flex items-baseline justify-between gap-2">
          <h3 className={`truncate text-[15px] font-semibold ${unreadCount > 0 ? 'text-[#1A1A1A]' : 'text-[#444]'}`}>
            {participant.displayName}
          </h3>
          {lastMessageAt && (
            <span className="shrink-0 text-[12px] text-[#AAAAAA]">
              {formatRelativeTime(lastMessageAt)}
            </span>
          )}
        </div>

        <div className="flex items-center gap-1.5">
          <CheckCheck size={13} color="#B87333" />
          <p className={`truncate text-[13px] ${unreadCount > 0 ? 'font-medium text-[#666]' : 'text-[#888]'}`}>
            {lastMessage || 'メッセージはありません'}
          </p>
        </div>
      </button>
    </div>
  );
}
